export const viewTypes = {
  GRID: 'grid',
  list: 'list',
};

export const viewCountTypes = {
  COUNT25: 25,
  COUNT50: 50,
  COUNT75: 75,
};

export const sortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const sortFields = {
  NAME: 'name',
  MODIFIEDAT: 'modifiedAt',
};

export const maxPageLinks = 5; // how many pages we show on pagination - < 1 2 3 4 5 >

export const SET_ALFRESCO_FOLDER_STRUCTURE = 'SET_ALFRESCO_FOLDER_STRUCTURE';

export const ALFRESCO_FOLDER_DATA = 'alfrescoFolderData';
